import React, { Component, Fragment } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import authService from '../../services/AuthService';
import api, { apiResponseHandler, apiErrorHandler } from '../../services/AxiosService';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';
import moment from 'moment';
import './CadeReport.css';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';

class CadeReportAssessment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            providerId: props.providerId,
            isAssessmentComplete: props.isAssessmentComplete,
            clinicianName: props.clinicianName,
            clinicianDegrees: props.clinicianDegrees,
            patientFirstName: props.patientFirstName,
            patientLastName: props.patientLastName,
            patientBirthDate: props.patientBirthDate,
            patientAgeWhenTested: props.patientAgeWhenTested,
            testDate: props.testDate,
            testsAdministered: props.testsAdministered,
            reportDate: props.reportDate,
            reasonForReferral: props.reasonForReferral,
            testResults: props.testResults,
            diagnosticImpressions: props.diagnosticImpressions,
            summary: props.summary,
            nextStep1: props.nextStep1,
            nextStep2: props.nextStep2,
            nextStep3: props.nextStep3,
            nextStep4: props.nextStep4,
            nextStep5: props.nextStep5,
            readonly: props.readonly,
            includeAssessmentRadarChart: props.includeAssessmentRadarChart,
            includeAssessmentBarChart: props.includeAssessmentBarChart,
            reportUrl: null,
            mayDownloadReport: false,
            downloadReportType: null,
            generateProgressButtonText: "Generate Progress Report",
            generateDiagButtonText: "Generate Diagnostic Assessment",
            generateNonDiagButtonText: "Generate Concerns Assessment", 
            showGenerateButton: true
        }

        if (!this.state.isAssessmentComplete && authService.userType == this.props.cadeModeFor) {
            this.state.generateProgressButtonText = "Answer all assessment questions prior to generating report";
            this.state.generateDiagButtonText = "Answer all assessment questions prior to generating report";
            this.state.generateNonDiagButtonText = "Answer all assessment questions prior to generating report";
            this.state.showGenerateButton = false;
        }
        this.needsSave = false;
        this.accordionActiveKey = this.props.accordionActiveKey;
    }

    generateReport = (reportType) => {
        if (!this.state.isAssessmentComplete) {
            alertPopup("info", this.props.who + " assessment is incomplete and the report cannot be generated.");
            return;
        }

        //alert(this.state.patientFirstName + " " + this.state.patientLastName + " " + this.state.patientBirthDate + " " + encPerson);
        if (reportType == "diagassess") {
            if (this.props.cadeModeFor != 1) {
                alertPopup('warning', "Diagnostic assessments can only be generated using Your Input (not other's input).  The report will be generated as requested but will use Your Input.");
            }
            this.setState({ generateDiagButtonText: "Generating report.  Please wait..." });
        }
        else if (reportType == "nondiagassess") {
            this.setState({ generateNonDiagButtonText: "Generating report.  Please wait..." });
        }
        else {
            this.setState({ generateProgressButtonText: "Generating report.  This may take some time.  Please wait..." });
        }
        
        let url = "assessment/" + this.state.assessmentId + "/report/" + this.state.providerId + "/uid/" + authService.authenticatedUserId + "/ut/" + this.props.cadeModeFor + "/type/" + reportType;  
        api.get(url, {
            timeout: 60000,
            headers: {
                Authorization: 'Bearer ' + authService.token,
                responseType: 'arraybuffer',
                //'Content-Type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                //'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                //'Content-Type': "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                //'Content-Disposition': "attachment;filename='assessmentReport.docx'"
            }
        })
        .then((response) => {
            let base64js = require('base64-js');
            if (response.status == 200) {
                let decodedData = base64js.toByteArray(response.data.fileContents); // can't use atob for arraybuffers
                let reportBlob = new Blob([decodedData], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                this.setState({ reportUrl: window.URL.createObjectURL(reportBlob), mayDownloadReport: true, downloadReportType: reportType});
            }
            else {
                apiErrorPopup(apiResponseHandler(response));
                this.setState({ reportUrl: null, mayDownloadReport: false });
            }

            if (reportType == "diagassess") {
                this.setState({ generateDiagButtonText: "Generate Diagnostic Assessment"});
            }
            else if (reportType == "nondiagassess") {
                this.setState({ generateNonDiagButtonText: "Generate Concerns Assessment"});
            }
            else {
                this.setState({ generateProgressButtonText: "Generate Progress Report"});
            }
        })
        .catch(error => {
            // Major problem - should not happen.
            apiErrorPopup(apiErrorHandler(error));
            if (reportType == "diag") {
                this.setState({ generateDiagButtonText: "Generate Diagnostic Assessment", reportUrl: null });
            }
            else if (reportType == "nondiagassess") {
                this.setState({ generateNonDiagButtonText: "Generate Concerns Assessment", reportUrl: null });
            }
            else {
                this.setState({ generateProgressButtonText: "Generate Progress Report", reportUrl: null });
            }
        });
    }

    clinicianNameChangeHandler = (event) => {
        // Not wanting a react state change so setting directly.
        this.state.clinicianName = event.target.value;
        this.needsSave = true;
    }

    clinicianDegreesChangeHandler = (event) => {
        this.state.clinicianDegrees = event.target.value;
        this.needsSave = true;
    }

    testDateChangeHandler = (event) => {
        this.state.testDate = event.target.value;
        this.needsSave = true;
    }

    testsAdministeredChangeHandler = (event) => {
        this.state.testsAdministered = event.target.value;
        this.needsSave = true;
    }

    testAgeChangeHandler = (event) => {
        this.state.patientAgeWhenTested = event.target.value;
        this.needsSave = true;
    }

    reasonChangeHandler = (event) => {
        this.state.reasonForReferral = event.target.value;
        this.needsSave = true;
    }

    testResultsChangeHandler = (event) => {
        this.state.testResults = event.target.value;
        this.needsSave = true;
    }

    diagnosticImpressionsChangeHandler = (event) => {
        this.state.diagnosticImpressions = event.target.value;
        this.needsSave = true;
    }

    summaryChangeHandler = (event) => {
        this.state.summary = event.target.value;
        this.needsSave = true;
    }

    ns1ChangeHandler = (event) => {
        this.state.nextStep1 = event.target.value;
        this.needsSave = true;
    }

    ns2ChangeHandler = (event) => {
        this.state.nextStep2 = event.target.value;
        this.needsSave = true;
    }

    ns3ChangeHandler = (event) => {
        this.state.nextStep3 = event.target.value;
        this.needsSave = true;
    }

    ns4ChangeHandler = (event) => {
        this.state.nextStep4 = event.target.value;
        this.needsSave = true;
    }

    ns5ChangeHandler = (event) => {
        this.state.nextStep5 = event.target.value;
        this.needsSave = true;
    }

    includeRadarChangeHandler = (event) => {
        this.setState({includeAssessmentRadarChart: event.target.checked});
        this.needsSave = true;
    }

    includeBarChangeHandler = (event) => {
        this.setState({ includeAssessmentBarChart: event.target.checked });
        this.needsSave = true;
    }

    validateDate = (aDate) => {
        return moment(aDate, 'M/D/YYYY', true).isValid();
    }

    saveHandler = () => {
        if (this.needsSave && !this.state.readonly) {
            // Validation checks prior to the save
            if (this.state.testDate != null && this.state.testDate.length > 0 && !this.validateDate(this.state.testDate)) {
                alertPopup('error', "Invalid test date format " + this.state.testDate + ".  Dates must be in the form mm/dd/yyyy");
                return;
            }
            this.needsSave = false;
            this.props.saveHandler(
                this.accordionActiveKey,
                this.state.assessmentId,
                this.state.clinicianName,
                this.state.clinicianDegrees,
                this.state.patientAgeWhenTested,
                this.state.testDate,
                this.state.testsAdministered,
                this.state.reportDate,
                this.state.reasonForReferral,
                this.state.testResults,
                this.state.diagnosticImpressions,
                this.state.summary,
                this.state.nextStep1,
                this.state.nextStep2,
                this.state.nextStep3,
                this.state.nextStep4,
                this.state.nextStep5,
                this.state.includeAssessmentRadarChart,
                this.state.includeAssessmentBarChart
            );
        }
    }

    reportDownloadHandler = () => {
        this.setState({
            mayDownloadReport: false
        });
        return true;
    }

    accordionSelected = (key) => {
        this.accordionActiveKey = key;
    }

    render() {
        let downloadLabel = (isNullOrEmpty(this.state.reportUrl) || this.state.mayDownloadReport == false) ? null : "Click to Download Report";
        let reportSource = "using " + this.props.who + " responses";

        return (
            <Fragment>
                <h6 style={{ marginTop: 40 }}> Select the report type, fill-in any necessary fields and then click "Generate" to get a <i>download link</i> to your report</h6>
                <Accordion className="cadeReport_accordion" defaultActiveKey={this.accordionActiveKey}>
                    {authService.isClearClinician &&
                        <Card>
                            <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey="0" onClick={this.accordionSelected.bind(this, "0")}>
                                    Diagnostic Assessment
                            </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                {this.state.showGenerateButton &&
                                    <Fragment>
                                    <h6 className="cadeReport_reportSource">The Diagnostic Assessment will be generated USING YOUR RESPONSES</h6>
                                    
                                        <Button className="cadeReport_genReportButton" variant="primary" size="lg" block onClick={this.generateReport.bind(this, "diagassess")}>
                                            {this.state.generateDiagButtonText}
                                        </Button>
                                        </Fragment>
                                    }
                                    {!this.state.showGenerateButton &&
                                        <p>{this.state.generateDiagButtonText}</p>
                                    }
                                    
                                    {(this.state.downloadReportType == "diagassess") &&
                                        <p className="cadeReport_downloadLink"><a href={this.state.reportUrl} download="Clear Diagnostic Assessment.docx" onClick={this.reportDownloadHandler} >{downloadLabel}</a></p>
                                    }
                                    
                                    <div onMouseLeave={this.saveHandler}>
                                        <Form>
                                            <h4 className="cadeReport_sectionHeading">Diagnosing Clinician Information</h4>
                                            <p className="cadeReport_subsectionHeading">Name</p>
                                            <Form.Group controlId="reportClinicianName">
                                                <Form.Control id="clinicianName" as="input" type="text" defaultValue={this.state.clinicianName} placeholder="Clinician full name" onChange={this.clinicianNameChangeHandler} disabled={this.state.readonly} />
                                            </Form.Group>

                                            <p className="cadeReport_subsectionHeading">Title/Degrees</p>
                                            <Form.Group controlId="reportClinicianDegrees">
                                                <Form.Control id="clinicianDegrees" as="input" type="text" defaultValue={this.state.clinicianDegrees} placeholder="Title/Degrees" onChange={this.clinicianDegreesChangeHandler} disabled={this.state.readonly} />
                                            </Form.Group>

                                            <h4 className="cadeReport_sectionHeading">Test Information</h4>
                                            <p className="cadeReport_subsectionHeading">Test Date</p>
                                            <Form.Group controlId="reportTestDate">
                                                <Form.Control id="testDate" as="input" type="text" defaultValue={this.state.testDate} placeholder="Test date (mm/dd/yyyy)" onChange={this.testDateChangeHandler} disabled={this.state.readonly} />
                                            </Form.Group>
                                            <h5 className="cadeReport_subsectionHeading">Patient age when tested</h5>
                                            <Form.Group controlId="reportTestAge">
                                                <Form.Control id="patentAgeWhenTested" as="input" type="text" defaultValue={this.state.patientAgeWhenTested} placeholder="Patient age when tested (e.g., 3 years 4 months)" onChange={this.testAgeChangeHandler} disabled={this.state.readonly} />
                                            </Form.Group>
                                            <h5 className="cadeReport_subsectionHeading">Tests Administered</h5>
                                            <Form.Group controlId="reportTestsAdmin">
                                                <Form.Control id="testsAdministered" as="textarea" rows="6" type="text" defaultValue={this.state.testsAdministered} placeholder="Tests administered (e.g., CADE, ADOS)" onChange={this.testsAdministeredChangeHandler} disabled={this.state.readonly} />
                                            </Form.Group>

                                            <h4 className="cadeReport_sectionHeading">Report Date</h4>
                                            <Form.Group controlId="reportReportDate">
                                                <Form.Label>{this.state.reportDate}</Form.Label>
                                            </Form.Group>

                                            <h4 className="cadeReport_sectionHeading">Reason for Referral</h4>
                                            <Form.Group controlId="reportReason">
                                                <Form.Control id="reasonForReferral" as="textarea" rows="8" defaultValue={this.state.reasonForReferral} onChange={this.reasonChangeHandler} placeholder="State the reasons why you made this assessment" disabled={this.state.readonly} />
                                            </Form.Group>

                                            <h4 className="cadeReport_sectionHeading">Test Results</h4>
                                            <Form.Group controlId="reportResults">
                                            <Form.Control id="testResults" as="textarea" rows="8" defaultValue={this.state.testResults} onChange={this.testResultsChangeHandler} placeholder="Indicate the results of your testing" disabled={this.state.readonly} />
                                            </Form.Group>

                                            <h4 className="cadeReport_sectionHeading">Diagnostic Impressions</h4>
                                            <Form.Group controlId="reportImpressions">
                                            <Form.Control id="diagnosticImpressions" as="textarea" rows="8" defaultValue={this.state.diagnosticImpressions} onChange={this.diagnosticImpressionsChangeHandler} placeholder="State your specific diagnostic findings" disabled={this.state.readonly} />
                                            </Form.Group>

                                            <h4 className="cadeReport_sectionHeading">Summary</h4>
                                            <Form.Group controlId="reportSummary">
                                            <Form.Control id="summary" as="textarea" rows="8" defaultValue={this.state.summary} onChange={this.summaryChangeHandler} placeholder="Provide an overall assessment summary" disabled={this.state.readonly} />
                                            </Form.Group>

                                            <h4 className="cadeReport_sectionHeading">Next Steps</h4>
                                            <Form.Group controlId="reportNs1">
                                                <Form.Control id="ns1" as="textarea" rows="5" defaultValue={this.state.nextStep1} placeholder="Optional information about who to see and what to do next" onChange={this.ns1ChangeHandler} disabled={this.state.readonly} />
                                            </Form.Group>

                                            <Form.Group controlId="reportNs2">
                                            <Form.Control id="ns2" as="textarea" rows="5" defaultValue={this.state.nextStep2} onChange={this.ns2ChangeHandler} placeholder="At most 5 next-step items may be included"  disabled={this.state.readonly} />
                                            </Form.Group>

                                            <Form.Group controlId="reportNs3">
                                            <Form.Control id="ns3" as="textarea" rows="5" defaultValue={this.state.nextStep3} onChange={this.ns3ChangeHandler} placeholder="All next-steps are optional"  disabled={this.state.readonly} />
                                            </Form.Group>

                                            <Form.Group controlId="reportNs4">
                                            <Form.Control id="ns4" as="textarea" rows="5" defaultValue={this.state.nextStep4} onChange={this.ns4ChangeHandler} placeholder="Any next-steps left blank will be omitted from the report" disabled={this.state.readonly} />
                                            </Form.Group>

                                            <Form.Group controlId="reportNs5">
                                            <Form.Control id="ns5" as="textarea" rows="5" defaultValue={this.state.nextStep5} onChange={this.ns5ChangeHandler} placeholder="Next step #5 should you have one"  disabled={this.state.readonly} />
                                            </Form.Group>

                                            {false &&
                                                <Fragment>
                                                    <p className="cadeReport_sectionHeading">Include Charts</p>
                                                    <Form.Check id="includeRadar" type="checkbox" label="Include Radar Chart in report" checked={this.state.includeAssessmentRadarChart} onChange={this.includeRadarChangeHandler} disabled={this.state.readonly} />
                                                    <Form.Check id="includeBar" type="checkbox" label="Include Bar Chart in report" checked={this.state.includeAssessmentBarChart} onChange={this.includeBarChangeHandler} disabled={this.state.readonly} />
                                                </Fragment>
                                            }
                                        </Form>
                                    </div>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    }
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey="1" onClick={this.accordionSelected.bind(this, "1")}>
                                Concerns Assessment (non-diagnostic) 
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                {this.state.showGenerateButton &&
                                    <Fragment>
                                        <h6 className="cadeReport_reportSource">The Concerns Assessment will be generated {reportSource.toUpperCase()}</h6>
                                        <Button className="cadeReport_genReportButton" variant="primary" size="lg" block onClick={this.generateReport.bind(this, "nondiagassess")}>
                                            {this.state.generateNonDiagButtonText}
                                        </Button>
                                    </Fragment>
                                }
                                {!this.state.showGenerateButton &&
                                    <p>{this.state.generateNonDiagButtonText}</p>
                                }
                                
                                {this.state.downloadReportType == "nondiagassess" &&
                                    <p className="cadeReport_downloadLink"><a href={this.state.reportUrl} download="Clear Concerns Assessment.docx" onClick={this.reportDownloadHandler} >{downloadLabel}</a></p>
                                }
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle as={Button} variant="link" eventKey="2" onClick={this.accordionSelected.bind(this, "1")}>
                                Progress Assessment
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                {this.state.showGenerateButton &&
                                    <Fragment>
                                        <h6 className="cadeReport_reportSource">The Progress Assessment will be generated {reportSource.toUpperCase()}</h6>
                                        <Button className="cadeReport_genReportButton" variant="primary" size="lg" block onClick={this.generateReport.bind(this, "progress")}>
                                            {this.state.generateProgressButtonText}
                                        </Button>
                                    </Fragment>
                                }
                                {!this.state.showGenerateButton &&
                                    <p>{this.state.generateProgressButtonText}</p>
                                }

                                {this.state.downloadReportType == "progress" &&
                                    <p className="cadeReport_downloadLink"><a href={this.state.reportUrl} download="Clear Progress Assessment.docx" onClick={this.reportDownloadHandler} >{downloadLabel}</a></p>
                                }
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                
            </Fragment>

        )
    }
}

export default CadeReportAssessment;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeReportAssessment.js